import {
    NinchatActionType,
    NinchatUpdateChannelAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {RootState} from 'store'

import {createAsyncThunk} from '@reduxjs/toolkit'
import {jitsiHangup} from 'actions/jitsi'

const actionTypePrefix = 'NINCHAT/action'

export const updateChannel = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatUpdateChannelAction}`,
    async (arg: NinchatActionParams<NinchatUpdateChannelAction>, {
        rejectWithValue, getState, dispatch,
    }) => {
        const {...params} = arg

        const {
            activeVideoChannelId, isActive,
        // eslint-disable-next-line no-extra-parens
        } = (getState() as RootState).jitsi

        // if there is active jitsi meeting and we are closing channel
        if (isActive && activeVideoChannelId === params.channel_id && params?.channel_attrs?.closed) {
            await dispatch(jitsiHangup())
        }

        params.action = NinchatActionType.NinchatUpdateChannelAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
